import { put, takeLatest, all, call } from "redux-saga/effects";
import { customReports } from "../../constants/actionTypes";
import { toasterFlags } from "../../constants/componentConstants";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import {
  getCustomFiltersListFailure,
  getCustomFiltersListSuccess,
  getCustomReportsAllDataSuccess,
  getCustomReportsFailure,
  getCustomReportsSuccess,
} from "../actions";
import { customFilterRequestApi, customReportRequestApi } from "../api/customReports";

export function* getCustomFilterRequest() {
  try {
    const data = yield call(customFilterRequestApi);
    if (data?.status === statusCode.Ok200) {
      yield put(getCustomFiltersListSuccess(data?.data));
    } else {
      yield put(getCustomFiltersListFailure(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(getCustomFiltersListFailure(err));
  }
}
export function* getCustomReportRequest({ payload }) {
  try {
    const data = yield call(customReportRequestApi, payload?.urlParams, payload?.data);
    if (data?.status === statusCode.Ok200) {
      yield put(getCustomReportsSuccess(data?.data));
    } else {
      yield put(getCustomReportsFailure(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(getCustomReportsFailure(err));
  }
}

export function* getCustomReportAllDataRequest({ payload }) {
  try {
    const data = yield call(customReportRequestApi, payload?.urlParams, payload?.data);
    if (data?.status === statusCode.Ok200) {
      yield put(getCustomReportsAllDataSuccess(data?.data));
    } else {
      yield put(getCustomReportsFailure(data));
    }
  } catch (err) {
    yield put(getCustomReportsFailure(err));
  }
}

export function* customReportsWatcherSaga() {
  yield takeLatest(customReports.GET_CUSTOM_FILTER_REQUEST, getCustomFilterRequest);
  yield takeLatest(customReports.GET_CUSTOM_REPORT_REQUEST, getCustomReportRequest);
  yield takeLatest(customReports.GET_CUSTOM_REPORT_REQUEST_ALL_DATA, getCustomReportAllDataRequest);
}

export default function* customReportsSaga() {
  yield all([customReportsWatcherSaga()]);
}
